import webflow from '../../public/assets/platforms/minimal-platform-logo/webflow.svg';
import wix from '../../public/assets/platforms/wix.svg';
import joomla from '../../public/assets/platforms/minimal-platform-logo/joomla.svg';
import weebly from '../../public/assets/platforms/minimal-platform-logo/weebly.svg';
import shopify from '../../public/assets/platforms/minimal-platform-logo/shopify.svg';
import wordpress from '../../public/assets/platforms/minimal-platform-logo/wordpress.svg';
import shift4shop from '../../public/assets/platforms/minimal-platform-logo/shift4shop.svg';
import prestashop from '../../public/assets/platforms/minimal-platform-logo/prestashop.png';
import opencart from '../../public/assets/platforms/minimal-platform-logo/opencart.png';
import websitex5 from '../../public/assets/platforms/minimal-platform-logo/websitex5.svg';
import modx from '../../public/assets/platforms/minimal-platform-logo/modx.svg';
import nopcommerce from '../../public/assets/platforms/minimal-platform-logo/nopcommerce.png';

export const icons = {
	webflow,
	wix,
	joomla,
	weebly,
	shopify,
	wordpress,
	shift4shop,
	prestashop,
	websitex5,
	modx,
	opencart,
	nopcommerce,
};
